// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__vo5pr","header":"ReportDetails_header__tbAbH","title":"ReportDetails_title__2RE9J","left":"ReportDetails_left__k6Xc5"};